import { render, staticRenderFns } from "./disclosure_nav_item.vue.js?vue&type=template&id=99f7a0a6!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./disclosure_nav_item.vue?vue&type=template&id=99f7a0a6"
import script from "./disclosure_nav_item.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./disclosure_nav_item.vue?vue&type=script&lang=js"
export * from "./disclosure_nav_item.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./disclosure_nav_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99f7a0a6')) {
      api.createRecord('99f7a0a6', component.options)
    } else {
      api.reload('99f7a0a6', component.options)
    }
    module.hot.accept("./disclosure_nav_item.vue.js?vue&type=template&id=99f7a0a6!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./disclosure_nav_item.vue?vue&type=template&id=99f7a0a6", function () {
      api.rerender('99f7a0a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "super_sidebar/components/disclosure_nav_item.vue"
export default component.exports